function setAnchors() {
  let arrowMaskLeft = $('#scrolled-container .arrow-mask-left')
  let arrowMaskRight = $('#scrolled-container .arrow-mask-right')
  let leftArrow = $('.left-arrow')
  let rightArrow = $('.right-arrow')
  let anchors = $('.anchors')
  let anchorsContainer = $('#scrolled-container > div')
  let position = 0
  const moveBy = 250;

  if ($('body').data('pagetype') === 'home') {
    arrowMaskLeft = $();
    arrowMaskRight = $();
    leftArrow = $('[data-pagetype="home"] .left-arrow');
    rightArrow = $('[data-pagetype="home"] .right-arrow');
    anchorsContainer = $('[data-pagetype="home"] .black');
    anchors = $('[data-pagetype="home"] .anchors');
  }

  const moduleAnchors = document.querySelectorAll('.module-anchor')

  if (!anchors.length || !moduleAnchors.length) {
    $('#scrolled-container').hide()
    return
  }

  moduleAnchors.forEach((item) => {
    anchors.append(
      `<a class="anchor" href="#${item.id}">
        <h3 class="title">${item.getAttribute('data-anchortitle')}</h3>
      </a>`
    )
  })

  function checkPosition() {
    if (anchorsContainer.width() >= anchors.width() + position) {
      arrowMaskRight.hide()
    } else {
      arrowMaskRight.show()
    }
    if (position >= 0) {
      arrowMaskLeft.hide()
    } else {
      arrowMaskLeft.show()
    }
  }

  function moveAnchors(target = 0){
    const max = Math.ceil(-1 * (anchors.width() - anchorsContainer.width())) - 1;

    position = Math.ceil(Math.min(Math.max(target, max), 0));
    anchors.css({ 'left': position + 'px' });

    checkPosition();
  }

  moveAnchors(0);

  $(window).on('resize', () => {
    moveAnchors(0)
  });

  leftArrow.on('click', () => {
    moveAnchors(position + moveBy)
  })

  rightArrow.on('click', () => {
    moveAnchors(position - moveBy);
  })

  //swipe handling
  let touchstartX = null;
  let touchendX = 0;
  let swipeThreshold = 20;
  const checkDirection = function() {
    if (touchstartX === null || Math.abs(touchendX - touchstartX) < swipeThreshold) {
      return;
    }
    if (touchendX < touchstartX) {
      //next slide
      moveAnchors(position - moveBy);
    }
    else if (touchendX > touchstartX) {
      //previous slide
      moveAnchors(position + moveBy)
    }
  }
  document.addEventListener('touchstart', e => {
    if (!e.target.closest('#scrolled-container')) {
      touchstartX = null;
      return;
    }
    touchstartX = (e.changedTouches || e.touches)[0]?.screenX || null;
  });
  document.addEventListener('touchend', e => {
    if (touchstartX === null) {
      return;
    }
    touchendX = (e.changedTouches || e.touches)[0].screenX;
    checkDirection();
  });

  //scroll handling
  const headerEvents = {};
  window.addEventListener('scroll', () => {
    if(!document.querySelector('#scrolled-container') || !document.querySelector('#navcontainer')){
      return;
    }

    const anchorsHeight = document.querySelector('#scrolled-container').clientHeight
    const navHeight = document.querySelector('#navcontainer').clientHeight
    const headerHeight = anchorsHeight + navHeight
    const scrollTop = Math.ceil(window.scrollY)
    const body = $('html, body')

    let activeAnchorLink = null;
    moduleAnchors.forEach((item, index) => {
      const headerLink = document.querySelector(`[href="#${item.id}"]`)
      const anchorOffsetTop = item.offsetTop;
      const coorToScroll = anchorOffsetTop - headerHeight

      if (headerEvents[item.id]) {
        headerLink.removeEventListener('click', headerEvents[item.id]);
      }

      headerEvents[item.id] = (event) => {
        event.preventDefault()
        body.stop().animate({
          scrollTop: coorToScroll,
        }, 500);
      }

      headerLink.addEventListener('click', headerEvents[item.id]);

      if(scrollTop >= coorToScroll) {
        if (activeAnchorLink) {
          activeAnchorLink.classList.remove('active')
        }

        activeAnchorLink = headerLink;
        headerLink.classList.add('visited', 'active')
      }
      else {
        headerLink.classList.remove('visited', 'active')
      }
    })

    moveAnchorIntoView(activeAnchorLink);
  })

  function moveAnchorIntoView(link) {
    if (!link) {
      return;
    }

    const viewpointSize = window.innerWidth || document.documentElement.clientWidth;
    const outerPadding = anchorsContainer.get(0).getBoundingClientRect().left;
    const linkPositionLeft = link.offsetLeft;

    if (viewpointSize - outerPadding * 2 < link.offsetWidth) {
      moveAnchors(-1 * linkPositionLeft);
      return;
    }

    const linkPositionCenter = linkPositionLeft - viewpointSize / 2 + outerPadding + link.offsetWidth / 2;
    moveAnchors(-1 * linkPositionCenter);
  }

  function pushAnchorsRight(element) {
    if (element.classList.contains('visited')) {
      moveAnchors(position + moveBy);
    }
  }

  function pushAnchorsLeft(element) {
    function isInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.left >= 0 &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
    }

    if (!isInViewport(element) && !element.classList.contains('visited') &&  !element.classList.contains('active')) {
      moveAnchors(position - moveBy)
    }
  }
}

setAnchors()
